/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import tw from "twin.macro";
// import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line


import { ReactComponent as SvgDecoratorBlob1 } from "src/images/svg-decorator-blob-9.svg";

const Container = tw.div`relative bg-primary-500 text-gray-100 -mb-8 -mx-8 px-8 py-20 lg:py-24`;
const Content = tw.div`max-w-screen-xl mx-auto relative z-10`;

const Paragraph = tw.p`mb-4 leading-relaxed text-xl text-indigo-100`;
const Subtitle = tw.h2`text-3xl font-semibold text-indigo-100 mb-2`;

const CopywrightNotice = tw.p`text-center text-sm sm:text-base mt-8 md:mt-0 font-medium text-gray-400`;

const DecoratorBlobContainer = tw.div`absolute inset-0 overflow-hidden rounded-lg`;
const DecoratorBlob1 = tw(
  SvgDecoratorBlob1
)`absolute top-0 left-0 w-80 h-80 transform -translate-x-20 -translate-y-32 text-primary-700 opacity-50`;
const DecoratorBlob2 = tw(
  SvgDecoratorBlob1
)`absolute bottom-0 right-0 w-80 h-80 transform  translate-x-32 translate-y-48 text-primary-700 opacity-50`;

export default () => {
  return (
    <Container>
      <Content>
        {/* <Subtitle>Disclaimer</Subtitle> */}
        <Paragraph><Subtitle>Disclaimer</Subtitle> Blake Technologies provides AI-powered APIs for facial recognition, object detection, and text extraction. These services are intended for lawful use only. By using our services, you agree to comply with all applicable data protection and privacy laws in your jurisdiction.</Paragraph>
        {/* <Paragraph>
          The information provided by Blake Technologies on this website and through our API Dashboard App is for general informational purposes only. All information on the site and app is provided in good faith, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability or completeness of any information on the site or app.
        </Paragraph>
        <Paragraph>
          Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the site or app or reliance on any information provided on the site or app. Your use of the site and app and your reliance on any information on the site and app is solely at your own risk.
        </Paragraph> */}
        <CopywrightNotice>&copy; 2025-2026 Blake Technologies. All rights reserved</CopywrightNotice>
      </Content>
      <DecoratorBlobContainer>
        <DecoratorBlob1 />
        <DecoratorBlob2 />
      </DecoratorBlobContainer>
    </Container>
  );
};
